export default __webpack_public_path__ + "static/media/walletBackground3.aa5bd1d7.svg";